type Props = {
  totalSpent:    number | null
  storeName:     string | null
  onTotalChange: (value: number | null) => void
  onStoreChange: (value: string | null) => void
  onFinish:      () => void
  finishing:     boolean
  canFinish:     boolean
}

export function TotalStoreInput({
  totalSpent,
  storeName,
  onTotalChange,
  onStoreChange,
  onFinish,
  finishing,
  canFinish,
}: Props) {
  const totalStr = totalSpent != null ? totalSpent.toFixed(2) : ''

  function parseTotal(raw: string) {
    const cleaned = raw.replace(/[^0-9.]/g, '')
    if (cleaned === '') { onTotalChange(null); return }
    const parsed = parseFloat(cleaned)
    if (isNaN(parsed)) { onTotalChange(null); return }
    onTotalChange(parsed)
  }

  return (
    <div className="sticky bottom-4 z-10 pt-3 bg-gradient-to-b from-transparent via-cream/80 to-cream">
      <div className="rounded-[14px] bg-forest p-4 mb-2 flex justify-between items-start gap-4">
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-[0.15em] font-medium text-sand">
            Total
          </div>
          <div className="flex items-baseline gap-1 mt-0.5">
            <span className="font-serif text-[24px] text-forest-ink">$</span>
            <input
              type="text"
              inputMode="decimal"
              value={totalStr}
              onChange={e => parseTotal(e.target.value)}
              placeholder="0.00"
              className="flex-1 min-w-0 bg-transparent border-none font-serif text-[24px] text-forest-ink placeholder:text-sand/50 focus:outline-none"
            />
          </div>
        </div>
        <div className="text-right min-w-0" style={{ flexBasis: '40%' }}>
          <div className="text-[10px] uppercase tracking-[0.15em] font-medium text-sand">At</div>
          <input
            type="text"
            value={storeName ?? ''}
            onChange={e => onStoreChange(e.target.value || null)}
            placeholder="Store name"
            className="w-full mt-0.5 bg-transparent border-none font-serif italic text-[14px] text-forest-ink placeholder:text-sand/50 text-right focus:outline-none"
          />
        </div>
      </div>

      <button
        onClick={onFinish}
        disabled={!canFinish || finishing}
        className="w-full rounded-[14px] bg-forest p-[14px] text-[14px] font-bold tracking-[-0.01em] text-forest-ink disabled:opacity-50"
      >
        {finishing ? 'Finishing…' : 'Finish unpacking'}
      </button>

      {!canFinish && !finishing && (
        <p className="mt-2 text-center font-serif text-[11px] italic text-ink-muted">
          Confirm at least one item to finish.
        </p>
      )}
    </div>
  )
}
